<template>
  <component
    :is="componentName"
    @formSubmit="onFormSubmit"
    @formCancel="onFormCancel"
  />
</template>

<script>
import Api from '@/providers/Api.js';
import SubspecialtyForm from '@/components/subspecialty/SubspecialtyForm';
import MasterSubspecialtyForm from '@/components/subspecialty/MasterSubspecialtyForm';
import { ADD_SUBSPECIALTY_MUTATION } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'SubspecialtyCreate',
  components: {
    SubspecialtyForm,
    MasterSubspecialtyForm,
  },
  props: {
    isMaster: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentName: function () {
      return this.isMaster
        ? MasterSubspecialtyForm.name
        : SubspecialtyForm.name;
    },
  },
  methods: {
    onFormSubmit: async function (data) {
      try {
        const newSubspecialty = await Api.createSubspecialty(data);
        this.$store.commit(ADD_SUBSPECIALTY_MUTATION, newSubspecialty);
        this.$toasted.show('Subspecialty saved', { duration: 3000 });
        this.$router.go(-1);
      } catch (e) {
        process.env.NODE_ENV !== 'production' && console.error(e);
        handleServerErrorWithValidation(e, this.$toasted);
      }
    },
    onFormCancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>
